import { Outlet } from "react-router-dom";

export const AuthenticationRoute = () => {
  // if (!isRolePermitted) {
  //   return <Navigate to={Paths.Dashboard} replace />;
  // }

  return <Outlet />;
};
